import { TProgressItem } from '@components/progress_bar';

export const signupPersonalProgressSteps: (TProgressItem | undefined)[] = [
    {
        id: '1',
        title: 'Account'
    },
    {
        id: '2',
        title: 'Email'
    },
    // {
    //     id: '3',
    //     title: 'Verification'
    // },
    {
        id: '3',
        title: 'Phone'
    },
    {
        id: '4',
        title: ' Password'
    },
    {
        id: '5',
        title: 'Details'
    },
    {
        id: '6',
        title: 'Address'
    },
    {
        id: '7',
        title: 'Congrats'
    },
    undefined
];

export const signupBusinessProgressSteps: (TProgressItem | undefined)[] = [
    {
        id: '1',
        title: 'Account'
    },
    {
        id: '2',
        title: 'Email'
    },
    // {
    //     id: '3',
    //     title: 'Verification'
    // },
    {
        id: '3',
        title: 'Phone'
    },
    {
        id: '4',
        title: ' Password'
    },
    {
        id: '5',
        title: 'Details'
    },
    {
        id: '6',
        title: 'Business'
    },
    {
        id: '7',
        title: 'Addresses'
    },
    {
        id: '8',
        title: 'Congrats'
    },
    undefined
];

export const eTransferSendMoneyProgressSteps: (TProgressItem | undefined)[] = [
    {
        id: '1',
        title: 'Sender'
    },
    {
        id: '2',
        title: 'Recipient'
    },
    {
        id: '3',
        title: 'Amount'
    },
    {
        id: '4',
        title: 'Schedule'
    },
    {
        id: '5',
        title: 'Confirm'
    },
    {
        id: '6',
        title: 'Done'
    },
    undefined
];

export const eTransferRequestMoneyProgressSteps: (TProgressItem | undefined)[] = [
    {
        id: '1',
        title: 'Requester'
    },
    {
        id: '2',
        title: 'Recipient'
    },
    {
        id: '3',
        title: 'Amount'
    },
    {
        id: '4',
        title: 'Schedule'
    },
    {
        id: '5',
        title: 'Confirm'
    },
    {
        id: '6',
        title: 'Done'
    },
    undefined
];

export const payBillsPayBillsProgressSteps: (TProgressItem | undefined)[] = [
    {
        id: '1',
        title: 'Payee'
    },
    {
        id: '2',
        title: 'Amount'
    },
    {
        id: '3',
        title: 'Schedule'
    },
    {
        id: '4',
        title: 'Confirm'
    },
    {
        id: '5',
        title: 'Done'
    },
    undefined
];

export const setUpAppMFASteps: (TProgressItem | undefined)[] = [
    {
        id: '1',
        title: 'Get ready'
    },
    {
        id: '2',
        title: 'Connect app'
    },
    {
        id: '3',
        title: 'Verify code'
    },
    {
        id: '4',
        title: 'Backup Code'
    },
    {
        id: '5',
        title: 'Done'
    },
    undefined
];

export const createGiftCardSteps: (TProgressItem | undefined)[] = [
    {
        id: '1',
        title: 'Gift card details'
    },
    {
        id: '2',
        title: 'Recipient'
    },
    {
        id: '3',
        title: 'Confirm'
    },
    {
        id: '4',
        title: 'Done'
    },
    undefined
];
